<template>
  <div style="text-align: center; line-height: 500px;font-size: 20px;">
    {{text}}
    <div v-if="type.includes('mobile')" class="mobile">
      <img src="../../../static/m_code.png" alt srcset />
    </div>
  </div>
</template>
<script>
let that;
export default {
  name: "App",
  data() {
    return {
      text: "",
      type:""
    };
  },
  created() {
    // let isLogout=sessionStorage.getItem('isLogout')
    // if(isLogout=='true'){//用户处于退出登录状态

    var ua = navigator.userAgent.toLowerCase();
    var isWeixin = ua.indexOf("micromessenger") != -1;
    // let isLogout=sessionStorage.getItem('isLogout')
    // if(isLogout=='true'){//用户处于退出登录状态
    var type = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
      ? "mobile"
      : "PC";
    if (type == "mobile") {
      if (isWeixin) {
        this.type = "wxmobile";
      } else {
        this.type = "mobile";
        // this.text = "请在微信打开此链接~";
      }
    } else {
      this.type = "";
      this.text = "网站域名不存在,请输入正确网站地址";
    }

    // var type = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
    //   ? "mobile"
    //   : "PC";
    // if (type == "mobile") {
    //   // this.text = "请用电脑访问,APP不支持";
    //   this.typeShow = true;
    // } else {
    //   this.text = "网站域名不存在,请输入正确网站地址";
    // }
  },
  methods: {}
};
</script>
<style scoped>
.mobile {
  width: 100%;
  height: 100%;
  background: url("../../../static/m_bg.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 1;
}
.mobile img {
  display: block;
  height: 400px;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 1;
}
</style>




// WEBPACK FOOTER //
// src/pages/home/null.vue